import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from './components/layout/header';
import Todos from './components/Todo';
import AddTodo from './components/AddTodo';
// import { v4 as uuidv4 } from 'uuid';
import About from './components/pages/About';
import axios from "axios";
import './App.css';

class App extends Component{

state = {

  todos: [  ]
};

componentDidMount() {
  axios
  // https://jsonplaceholder.typicode.com/todos
  .get("https://jsonplaceholder.typicode.com/todos?_limit=10")
  .then(res => this.setState({ todos: res.data }));
}


// Mark Complete

  markComplete = id => {
    this.setState({todos: this.state.todos.map(todo => {
      if(todo.id === id){
        todo.completed = !todo.completed
      }
      return todo;
    })
  });
  };

  delTodo = id => {
    axios.delete(`https://jsonplaceholder.typicode.com/todos/${id}`).then(res =>
      this.setState({
        todos: [...this.state.todos.filter(todo => todo.id !== id)]
      })
    );
  };

  AddTodo = title => {
    axios
      .post("https://jsonplaceholder.typicode.com/todos", {
        title,
        completed: false
      })
      .then(res => this.setState({ todos: [...this.state.todos, res.data] }));

    // this.setState({todos: [...this.state.todos, newTodo] });
  }; 

  render(){
    return ( 
      // I have an error in this code but stack overflow help me here's the link https://stackoverflow.com/questions/69975792/error-home-is-not-a-route-component-all-component-children-of-routes-mus
      <Router>
        <div className='App'>
          <Header />

          <Routes>
          <Route exact path="/ReactApp" element={<>
            <React.Fragment>
            <div className='container'>
            <AddTodo 
              AddTodo={this.AddTodo} 
            />

            <Todos 
              todos={this.state.todos} 
              markComplete={this.markComplete} 
              delTodo={this.delTodo}  
            />
            </div>
            </React.Fragment>
          </>} 
          />
          {/* in V6 you can't use component instead of component you can use element */}
          {/* <Route path='/about' component={About} /> */}
         <Route path="about" element={ <About/> } />
        </Routes>

        </div>
      </Router>
    );
  }
}

export default App;


